/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useEffect, useState } from "react";
import api from "../../services/AuthApi";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  LinearProgress,
  Radio,
  RadioGroup,
  TextField,
  IconButton,
  Alert
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling";
import Alerts from "../../errorHandeling/Alerts";
import AuthService from "../../services/AuthService";

const EditAdvancedSettingsModal = ({ rowData, open, onClose }) => {
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessages, setSuccessMessages] = useState([]);

  //for error handling
  const [iserror, setIserror] = useState(false);
  const [iserrorShow, setIserrorShow] = useState(false);
  const [isUnauhtError, setIsUnauhtError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  // Loading
  let getConfig = {
    headers: {},
  };

  useEffect(() => {
    const fetchData = () => {
      api
        .get("/settings/" + rowData?.setting, getConfig)
        .then((res) => {
          setValues(res.data.dataList[0]);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchData();
  }, [rowData, isUnauhtError]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  // Edit
  let postConfig = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const handleSaveRowEdits = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const editSettings = JSON.stringify(values);

    api
      .put("/settings", editSettings, postConfig)
      .then((res) => {
        setErrorMessages([]);
        setIserror(false);
        setErrorMessages([]);
        setIsUnauhtError(false);
        setIsSuccess(true);
        setSuccessMessages([res.data?.description]);
        setTimeout(() => {
          handleClearData();
          AuthService.LogoutWithoutAPI()
        }, 3000);
        
      })
      .catch((error) => {
        setIsSubmit(false);
        setIsSuccess(false);
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        );
      });
  };

  const handleClearData = () => {
    onClose();
    setValues([]);
    setIsLoading(true);
    setIsSubmit(false);
    setIsSuccess(false);
    setSuccessMessages([""]);
    setIserror(false);
    setIserrorShow(false);
    setIsUnauhtError(false);
    setErrorMessages([]);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth={true}
      PaperProps={{ style: { borderRadius: "10px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#116c6f",
          color: "white",
        }}
      >
        Update System Settings
        <IconButton
          aria-label="cancel"
          sx={{ color: "#fff" }}
          onClick={handleClearData}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSaveRowEdits}>
        <Alert severity="warning">
          You will be logged out following a settings update
        </Alert>
        <DialogContent dividers>
          {isLoading && <LinearProgress style={{ marginBottom: "16px" }} />}
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Grid container spacing={2} width="100%">
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  disabled
                  id="inputSetting"
                  variant="outlined"
                  name="setting"
                  label="Setting"
                  value={values.setting ? values.setting : ""}
                  required
                  onChange={handleOnChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="inputValue"
                  variant="outlined"
                  name="value"
                  label="Value"
                  value={values.value ? values.value : ""}
                  onChange={handleOnChange}
                  disabled={values.value===null? true:false}
                />
              </Grid>

              <Grid item xs={12}>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Active
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="active"
                    value={values.active ? values.active : false}
                    onChange={handleOnChange}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Active"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="In-active"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} mt={2}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  name="description"
                  label="Description"
                  multiline
                  rows={4}
                  value={values.description ? values.description : ""}
                  onChange={handleOnChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleClearData} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            loading={isSubmit}
            loadingPosition="start"
            startIcon={<SaveIcon />}
            variant="contained"
            color="success"
            type="submit"
          >
            Update
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
};

export default EditAdvancedSettingsModal;
